import React from "react";
interface props {
  className?: string;
  text: string;
  textColor?: string;
  bgColor?:string;
}
export default function SubHeadings({
  className,
  text,
  textColor = "text-primary-600",
  bgColor="bg-primary-600"
}: props) {
  return (
    <div  className={`w-max capitalize font-medium group ${textColor} ${className ?? ""}`}>
      <span>{text}</span>
      <div className={`w-[66%] h-[2px] ${bgColor} animate-expandHorizontal delay-200  transition-all ease-in-out  mt-1  `}></div>
    </div>
  );
}
